import type React from "react";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import GenericLoader from "@/components/GenericLoader.tsx";
import { useFinancesStore } from "@/features/finances/store/useFinancesStore.tsx";

interface Props {
  children: React.ReactNode;
}

export default function FinancesWrapper({ children }: Props) {
  const { t } = useTranslation("finances");
  const { data: financesData, isLoading, error, refetch } = useFinancesStore();

  useEffect(() => {
    if (!financesData && !isLoading) {
      refetch();
    }
  }, [financesData, isLoading]);

  if (error) {
    return (
      <div className="flex h-[calc(100dvh_-_4rem)] items-center justify-center">
        <div className="text-center">
          <h2 className="text-accent-foreground text-xl font-semibold">Error</h2>
          <p className="text-muted-foreground mt-2">{error}</p>
          <button
            className="bg-accent-foreground text-background hover:bg-accent-foreground/90 mt-4 rounded-lg px-4 py-2"
            onClick={refetch}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <title>{`${t("title", "Finances")} - Ximly`}</title>
      {isLoading && <GenericLoader className={"fixed top-0 left-0 z-50"} />}
      {children}
    </>
  );
}
